module.exports = __webpack_public_path__ + "img/eight7Orange.d80da22d.jpg";